<div class="row">

  <div class="col-md-6" style="padding-left: 20px;">

    @if (relations) {
      <h5 class="hub-level-1-label">Primary Strategy</h5>
    }

    @if (primaryRelatedStrategies.length || primaryProposedStrategies.length) {
      <div class="hub-pill-list">
        @for (relation of primaryRelatedStrategies; track trackByFn($index, relation)) {
          <span>
            <a [routerLink]="'/portfolio/' + relation.relatedProjectId"
              class="badge-prio-strategy badge font-size-lg mr-1 mb-1">
              <i class="icon-loop3 mr-1"
              [ngClass]="{'d-none' : !isVerified(relation, backwardRelations, true)}"></i>
              {{relation.relatedProject?.name}}
            </a>
          </span>
        }
        @for (relation of primaryProposedStrategies; track trackByFn($index, relation)) {
          <span class="proposed-relation">
            <a [routerLink]="'/portfolio/' + relation.projectId" class="badge-primary badge font-size-lg mr-1 mb-1"
              tooltip="This relation is not confirmed" placement="top">
              {{relation.project?.name}}
            </a>
          </span>
        }
      </div>
    }

    @if (!primaryRelatedStrategies.length && !primaryProposedStrategies.length) {
      <div class="no-relations-warning">
        This project does not have a confirmed primary relation to a strategy.
      </div>
    }


    @if (relations) {
      <h5 class="hub-level-1-label">Additional Strategies</h5>
    }

    @if (additionalRelatedStrategies.length || additionalProposedStrategies.length) {
      <div class="hub-pill-list">
        @for (relation of relations; track trackByFn($index, relation)) {
          <span>
            @if (!relation.isPrimary) {
              <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-other-strategy badge font-size-lg mr-1 mb-1">
                <i class="icon-loop3 mr-1"
                [ngClass]="{'d-none' : !isVerified(relation, backwardRelations, false)}"></i>
                {{relation.relatedProject?.name}}
              </a>
            }
          </span>
        }
        @for (relation of proposedRelations; track trackByFn($index, relation)) {
          <span class="proposed-relation">
            @if (!relation.isPrimary) {
              <a [routerLink]="'/portfolio/' + relation.project?.projectId"
                class="badge-primary badge font-size-lg mr-1 mb-1" tooltip="This relation is not confirmed"
                placement="top">
                {{relation.project?.name}}
              </a>
            }
          </span>
        }
      </div>
    }

    @if (!additionalRelatedStrategies.length && !additionalProposedStrategies.length) {
      <div class="no-relations-warning"
        >
        This project does not have any confirmed additional relations to strategies
      </div>
    }

    @if (relations.length) {
      <div class="mt-1 text-muted font-size-sm">
        <i class="icon-loop3 mr-1 ml-1 text-muted round-rounded"></i> indicates a reciprocal relationship
        between Project and Strategy
      </div>
    }

  </div>

  <div class="col-md-6">

    <h5 class="hub-level-1-label">Region(s)</h5>

    <ul class="hub-bulleted-list">
      @for (regionName of regionNames; track regionName) {
        <li>
          {{ regionName }}
        </li>
      }
    </ul>

    <h5 class="hub-level-1-label">Division(s)</h5>

    <ul class="hub-bulleted-list">
      @for (divisionName of divisionNames; track divisionName) {
        <li>
          {{ divisionName }}
        </li>
      }
    </ul>

    <h5 class="hub-level-1-label">Business Unit(s)</h5>

    <div class="hub-pill-list">
      @for (bu of projectBusinessUnits; track bu) {
        <span>
          @if (bu.isLeadBusinessUnit) {
            <a>
              <span class="badge badge-info font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
            </a>
          }
          @if (!bu.isLeadBusinessUnit) {
            <a>
              <span class="badge badge-info-secondary font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
            </a>
          }
        </span>
      }
    </div>

    <h5 class="hub-level-1-label">Related Program Management</h5>

    @if (programManagementRecords.length) {
      <div class="hub-pill-list">
        @for (programManagementRecord of programManagementRecords; track programManagementRecord) {
          <span>
            <a [routerLink]="'/portfolio/' + programManagementRecord.projectId">
              <span class="badge badge-primary font-size-lg mr-1 mb-1">{{ programManagementRecord.name }}</span>
            </a>
          </span>
        }
      </div>
    }

    @if (programManagementRecords.length === 0) {
      <div class="no-relations-warning" style="color: #999;">
        A Program Management has not identified this record as part of their portfolio.
      </div>
    }

    <h5 class="hub-level-1-label">Related Whole System</h5>

    @if (wholeSystems.length) {
      <div class="hub-pill-list">
        @for (ws of wholeSystems; track ws) {
          <span>
            <a [routerLink]="'/portfolio/' + ws.projectId">
              <span class="badge badge-primary font-size-lg mr-1 mb-1">{{ ws.name }}</span>
            </a>
          </span>
        }
      </div>
    }

    @if (wholeSystems.length === 0) {
      <div class="no-relations-warning" style="color: #999;">
        A Whole System has not identified this record as part of their portfolio.
      </div>
    }

  </div>
